import { useParams, useNavigate } from 'react-router-dom';
import ComicCard from './ComicCard';
import './SerieDetail.css';

function SerieDetail({ albums, series }) {
  const { serieSlug } = useParams();
  const navigate = useNavigate();
  
  // Find the serie by slug (we'll use serie name as slug)
  const serie = series.find(s => 
    s.nom.toLowerCase().replace(/\s+/g, '-') === serieSlug
  );
  
  if (!serie) {
    navigate('/');
    return null;
  }
  
  // Get albums for this serie
  const serieAlbums = albums.filter(a => a.serieId === serie.id);
  
  return (
    <div className="serie-detail">
      <button className="back-button" onClick={() => navigate('/')}>
        ← Retour aux séries
      </button>
      
      <h1>{serie.nom}</h1>
      {serie.description && <p className="serie-description">{serie.description}</p>}
      
      <div className="card-grid">
        {serieAlbums.map(album =>
          <ComicCard 
            key={album.id}
            type="album"
            data={album}
          />
        )}
      </div>
    </div>
  );
}

export default SerieDetail;